import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Trending from "@/pages/home/components/Trending";
import HighLiked from "@/pages/home/components/HighLiked";
import Collection from "@/pages/home/components/Collection";
import EditorPick from "@/pages/home/components/EditorPick";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Subscribe from "@/pages/home/components/Subscribe";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";
import StructuredData from "@/pages/home/components/StructuredData";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      <StructuredData />
      <Navbar />
      <Hero />
      <Trending />
      <HighLiked />
      <Collection />
      <EditorPick />
      <Faq />
      <About />
      <Subscribe />
      <Footer />
      <BackToTop />
    </main>
  );
}